import { FC, PropsWithChildren } from 'react';
import { ProcessingAndReviewsFilters as Filters } from './processingAndReviewsFilters';
import { ProcessingAndReviewsList as List } from './processingAndReviewsList';
import type { ProcessingAndReviewsFiltersType } from './processingAndReviews';
import { ProcessingAndReviewsPagination as Pagination } from './processingAndReviewsPagination';
import { ProcessingAndReviews as Base } from './processingAndReviews';

interface ProcessingAndReviewsComponent extends FC<PropsWithChildren> {
  Filters: typeof Filters;
  List: typeof List;
  Pagination: typeof Pagination;
}

const ProcessingAndReviews = Base as ProcessingAndReviewsComponent;
ProcessingAndReviews.Filters = Filters;
ProcessingAndReviews.List = List;
ProcessingAndReviews.Pagination = Pagination;

export { ProcessingAndReviews };
export type { ProcessingAndReviewsFiltersType };
export * from './processingCountersProvider';
